import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import ParkingEnforcementApp from './ParkingEnforcementApp';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function ProjectEditor({ token, onLogout }) {
  const { slug } = useParams();
  const navigate = useNavigate();
  const isNew = slug === 'new';
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(!isNew);

  useEffect(() => {
    if (isNew) {
      setInitialData({ slug: '', branding: null, locations: [] });
      return;
    }
    const fetchProject = async () => {
      try {
        const res = await fetch(`${API_URL}/api/maps/${slug}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (res.status === 401) { onLogout(); return; }
        if (!res.ok) { navigate('/'); return; }
        const data = await res.json();
        setInitialData(data);
      } catch {
        navigate('/');
      } finally {
        setLoading(false);
      }
    };
    fetchProject();
  }, [slug, isNew, navigate, token, onLogout]);

  if (loading || !initialData) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-50">
        <div className="w-10 h-10 border-4 border-blue-500 border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  return (
    <ParkingEnforcementApp
      projectSlug={isNew ? null : slug}
      initialBranding={initialData.branding}
      initialLocations={initialData.locations}
      initialDestinations={initialData.destinations}
      onBackToDashboard={() => navigate('/admin')}
      token={token}
      onLogout={onLogout}
    />
  );
}
